import TopBox from './components/top section/TopBox'
import TechStack from "./components/Tech Section/TechStack";
import PublicationSection from "./components/Publications/PublicationSection";
import ProjectSection from "./components/Projects Section/ProjectSection";

function App() {
  return (
    <div>
      <TopBox/>
      <PublicationSection />
      <ProjectSection />
    </div>
  );
}

export default App;
